import { FrontendFilterType } from '../../../types/filters.type';

const DualRangeSlider:FrontendFilterType = 'dual_range_slider';
const IntegerToInteger:FrontendFilterType = 'integer_to_integer';
export { DualRangeSlider, IntegerToInteger };
